import './vendor/focus-visible.js';
import { useDynamicAdapt } from './vendor/dynamic-adapt.js'

useDynamicAdapt();
